import {
  faWhatsapp,
  // faFacebookF,
  faLinkedin,
  faGithub,
} from '@fortawesome/free-brands-svg-icons';

import { faEnvelope } from '@fortawesome/free-solid-svg-icons';

const contactInfo = [
  {
    id: 1,
    name: 'Whatsapp',
    icon: faWhatsapp,
    link: 'https://wa.me/59177703553?text=Buenas, me interesa sus servicios!!!',
  },
  {
    id: 2,
    name: 'Correo',
    icon: faEnvelope,
    link: 'mailto:jbticona2@gmail.com',
  },
  // {
  //   id: 3,
  //   name: 'Facebook',
  //   icon: faFacebookF,
  //   link: 'https://www.facebook.com/xBrandon95',
  // },
  {
    id: 5,
    name: 'Github',
    icon: faGithub,
    link: 'https://github.com/xBrandon95',
  },
  {
    id: 4,
    name: 'Linkedin',
    icon: faLinkedin,
    link: 'https://www.linkedin.com/in/john-brandon-ticona-apaza-09a738189/',
  },
];

export default contactInfo;
